import { type TUseRequestUpdaterProps, useRequest } from 'features/request/useRequest';
import { useResetStoreData } from 'features/request/useResetStoreData';
import type { BimIncludeContractObjectToWorkOrderChangeMutation } from 'gql/graphql';

import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { bimIncludeContractObjectToWorkOrderChangeGql } from '../bimWorkOrderChangeStructureQueries';

const requestId = 'bimIncludeContractObjectToWorkOrderChange';

interface IUseBimIncludeContractObjectToWorkOrderChange {
    workOrderChangeId?: number;
    onSuccess: (items?: number[] | null) => void;
    onError: () => void;
}

export const useBimIncludeContractObjectToWorkOrderChange = (props: IUseBimIncludeContractObjectToWorkOrderChange) => {
    const dispatch = useDispatch();

    const { workOrderChangeId, onError, onSuccess } = props;

    const [bimIncludeContractObjectToWorkOrderReset] = useResetStoreData({ requestId });

    const onSuccessLocal = useCallback(
        (depsVars: TUseRequestUpdaterProps<BimIncludeContractObjectToWorkOrderChangeMutation>) => {
            onSuccess(depsVars?.payload?.bimIncludeContractObjectToWorkOrderChange?.data);

            bimIncludeContractObjectToWorkOrderReset(undefined);
        },
        [bimIncludeContractObjectToWorkOrderReset, onSuccess],
    );

    const onErrorLocal = useCallback(() => {
        onError();
    }, [onError]);

    const [, bimIncludeContractObjectToWorkOrderStatus, , bimIncludeContractObjectToWorkOrderRequest] = useRequest({
        requestId,
        query: bimIncludeContractObjectToWorkOrderChangeGql,
        withEffect: false,
        dependenciesUpdater: onSuccessLocal,
        onErrorUpdater: onErrorLocal,
    });

    const bimIncludeContractObjectToWorkOrderMakeRequest = useCallback(
        (contractObjectId: number) => {
            dispatch(bimIncludeContractObjectToWorkOrderRequest({ contractObjectId, workOrderChangeId }));
        },
        [bimIncludeContractObjectToWorkOrderRequest, dispatch, workOrderChangeId],
    );

    useEffect(() => {
        bimIncludeContractObjectToWorkOrderReset(undefined);
    }, [bimIncludeContractObjectToWorkOrderReset]);

    return {
        bimIncludeContractObjectToWorkOrderStatus,
        bimIncludeContractObjectToWorkOrderMakeRequest,
    };
};
